// components/Sidebar.jsx
import React, { useState } from "react";
import {
  Drawer, Toolbar, Box, List, ListItemButton, ListItemIcon, ListItemText, Typography,
  ListItem
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  PostAdd as PostAddIcon,
  LinkedIn as LinkedInIcon,
  Cookie as CookieIcon,
  Slideshow,
  ManageAccounts as ManageAccountsIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { hasPermission, isAdmin } from "../../services/userService";



const Sidebar = ({ drawerWidth = 260, onNavigate }) => {
  const location = useLocation();
  const navigate= useNavigate()
  const [routeLoading, setRouteLoading] = useState(false);

  const allItems = [
    { label: "Twitter Manager", path: "/dashboard", icon: <DashboardIcon fontSize="small" />, key: "dashboard" },
    { label: "LinkedIn Management", path: "/linkedin-management", icon: <LinkedInIcon fontSize="small" />, key: "linkedin-management" },
    { label: "Post History", path: "/post-history", icon: <PostAddIcon fontSize="small" />, key: "post-history" },
    { label: "Manage PPT", path: "/ppt", icon: <Slideshow fontSize="small" />, key: "ppt" },
    { label: "Social Media Settings", path: "/social-media-settings", icon: <SettingsIcon fontSize="small" />, key: "social-media-settings" },
    { label: "Cookie Management", path: "/cookie-management", icon: <CookieIcon fontSize="small" />, key: "cookie-management" },
    { label: "Manage Users", path: "/manage-users", icon: <ManageAccountsIcon fontSize="small" />, key: "manage-users", adminOnly: true },
  ];

  const items = allItems.filter((item) => {
    if (item.adminOnly) return isAdmin();
    return hasPermission(item.key);
  });

  // Treat a route as selected if it matches exactly or is a child route
  const isSelected = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#F3F3EE",
          color: "#4F6669",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
          borderRight: "1px solid rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      <Toolbar sx={{ minHeight: "48px !important" }} />
      <Box sx={{ overflow: "auto", overflowX: "hidden", mt: 4 }}>
        <List component="nav" disablePadding>
          {items.map((item) => {
  const selected = isSelected(item.path);

  return (
    <ListItem
      key={item.key}
      button
      selected={selected}                            // <-- fix here
      onClick={() => {
        setRouteLoading(true);
        navigate(item.path);
        setTimeout(() => setRouteLoading(false), 800);
      }}
      sx={{
        mb: 1,
        mx: 1.5,
        borderRadius: 1,
        cursor: "pointer",
        height: 44,
         alignItems: "center",
        transition: "all 0.2s ease",
        backgroundColor: selected ? "#4D99A3" : "transparent",  // <-- use selected
        "&:hover": {
          backgroundColor: selected ? "#4D99A3" : "#f0f0f0",   // <-- use selected
        },
      }}
    >
      <ListItemIcon
          sx={{
            minWidth: 32,
            mr: 1,
            color: selected ? "#fff" : "#4D99A3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",        // <- center icon
          }}
        >
          {item.icon}
        </ListItemIcon>

      <ListItemText
        
        primary={item.label}
        primaryTypographyProps={{
          sx: {
            color: selected ? "#fff !important" : "#4D99A3",               // <-- use selected
            fontSize: "0.95rem",
            fontWeight: selected ? 700 : 500,
            pt:2.5
          },
        }}
      />
    </ListItem>
  );
})}

        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
